import type { StorageUsageResponse } from '../types/api'
import { apiClient } from './client'

export async function getStorageUsage(): Promise<StorageUsageResponse> {
  return apiClient.get<StorageUsageResponse>('/storage/usage')
}
